// extracted by mini-css-extract-plugin
export var offlineNotificaton = "fn_Lz";
export var offlineNotificaton__button = "fn_LD";
export var offlineNotificaton__header = "fn_LC";
export var offlineNotificaton__text = "fn_LF";
export var offlineNotificaton__withCookie = "fn_LB";